<template>
  <b-card class="no-border mt-3" no-body>
    <employee-table />
  </b-card>
</template>
<script>
import EmployeeTable from '@/components/EmployeeTable.vue';

export default {
  name: 'employee_list',
  components: {
    EmployeeTable,
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'employees', name: 'Employees' },
    ]);
  },
};
</script>


// WEBPACK FOOTER //
// src/views/pages/admin/employees/List.vue